import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { PruebaInterface } from "../../../../interfaces/PruebaInterface";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

//estilos
const classes = require("./PruebaEdit.module.css").default;

/**
 * UusarioEdit Component
 * @description: Componente que permite editar un prueba.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de pruebas.
 */

const PruebaEdit = () => {
  const { idPrueba } = useParams();
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();
  const [prueba, setPrueba] = useState<PruebaInterface>();
  const [show, setShow] = useState(false);

  //Variables de formulario
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: prueba?.nombre,
    },
  });

  //Función que trata el detalle de prueba.
  const transformData = useCallback(
    (variable: any) => {
      setPrueba(variable.data);
      reset(variable.data);
    },
    [reset]
  );

  //Se recibe el prueba a editar
  useEffect(() => {
    sendRequest(
      {
        url: `/prueba/${idPrueba}`,
      },
      transformData
    );
  }, [idPrueba, sendRequest, transformData]);

  //Función que solicita la edición del prueba
  const updatePrueba = (data: any) => {
    sendRequest(
      {
        url: `/prueba/${idPrueba}`,
        method: "PATCH",
        body: data,
      },
      (variable: any) => {
        setShow(true);
      }
    );
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!prueba) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Edición de la prueba {idPrueba}</h2>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Prueba actualizada"
          body="La prueba ha sido actualizada de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(updatePrueba)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 50,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 50 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default PruebaEdit;
